/**
 * 通用组件导出文件
 * 统一管理所有通用组件的导出
 */

export { LoadingScreen, SimpleLoader } from './loading-screen';
export { ShareResult, ShareButtonMobile } from './share-result';
export { ShareView } from './share-view';
export { SocialShareFloating } from './social-share-floating';
export { ShareCard, generateShareCardImage } from './share-card';
export { ShareSuccess } from './share-success';
export { ShareStats } from './share-stats';

// 分享相关的类型和工具函数
export type { ShareResultProps } from './share-result';
export type { SocialShareFloatingProps } from './social-share-floating';
export type { ShareSuccessProps } from './share-success';
export type { ShareStatsProps } from './share-stats';